import { rootStore } from 'store/root';
import { serverOptions } from './server-options';

// this is requested by Joshua
// Joshua's comment https://nexonamerica.slack.com/archives/C01CSLWRGN6/p1617058734004500?thread_ts=1616521397.131200&cid=C01CSLWRGN6

const { application, settings } = window;
const nxLogMiddlewareApiUrl = `${settings.hosts.accounts}/api/nxlog`;

function nxLogLegacySend(
    {
        sequenceno,
        prevfunnelstagename,
        funnelstagename,
        funnelinfo,
        productId,
    }: {
        sequenceno: number;
        prevfunnelstagename: string | null;
        funnelstagename: string;
        funnelinfo: string;
        productId: number | string;
    },
    opts: any = {}
) {
    if (typeof productId === 'string') productId = parseInt(productId, 10);
    const serviceId =
        productId === 10300
            ? serverOptions.find((one) => one.name === rootStore.session.selectedServer)?.serviceId // vidictus selected server's service id
            : rootStore.appStore.library.find((item) => item.productId === String(productId))?.currentBranch?.serviceId;

    if (!serviceId) return;

    const data = {
        createdate: new Date().toISOString(),
        serviceid: serviceId,
        ipaddress: null,
        clientip: null,
        nexonsn: application.globalUserNo,
        sessionid: application.sessionId,
        sequenceno,
        osplatform: 'arena',
        type: 'NXLog_Funnel',
        NXLog_Funnel: {
            prevfunnelstagename: prevfunnelstagename || null,
            funnelstagename,
            funnelinfo,
            arena_membership_no: parseInt(application.params.region, 10),
            arena_membership_user_no: application.userNo,
            arena_language: application.params.locale.split('_')[0],
            arena_environment: application.params.environment,
            arena_product_id: productId,
            ...opts,
        },
    };
    fetch(nxLogMiddlewareApiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}

export default nxLogLegacySend;
